<template>
  <div class="container">
    <div class="head_bg">
      <comm-head></comm-head>
      <div class="head_con">
        <div class="img" />
        <div></div>
        <div>
          <p>麦学园可能是你第二职业的起点</p>
          <p>麦学园的宗旨是为麦子们提供再学习的机会，让每一位麦子通过麦学园可以得到成长，为多麦的明天培养更多的优秀人才。</p>
        </div>
      </div>
    </div>

    <div class="bg_color_w">
      <div>
        <!-- <h1>讲师风采</h1>
        <el-carousel height="224px" indicator-position="none" :interval="5000" arrow="never">
          <el-carousel-item v-for="(item,index) in tea_list" :key="index">
            <div class="tea_style">
              <div
                class="tea_item"
                v-for="(_item,_index) in item"
                :class="{'mar_b_24':index<2}"
                :key="_index"
              >
                <img :src="_item.avatar" alt />
                <div>
                  <p>
                    <span>{{_item.name}}</span>
                    <span>{{_item.position}}</span>
                  </p>
                  <p>{{_item.describe}}</p>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel> -->
        <h1>麦学园课程</h1>
        <div class="xy_course">
          <div
            class="bubble_base b_c_o f_s_24 opac_5 animation_1"
            style="width:130px;height:130px;left:15px;top:110px;"
          >新人培训</div>
          <div
            class="bubble_base b_c_o opac_15"
            style="width:40px;height:40px;left:169px;top:77px;"
          ></div>
          <div
            class="bubble_base b_c_b opac_15"
            style="width:50px;height:50px;left:135px;top:316px;"
          ></div>
          <div
            class="bubble_base b_c_b f_s_28 opac_4 animation_2"
            style="width:160px;height:160px;left:193px;top:160px;"
          >基层管理</div>
          <div
            class="bubble_base b_c_o f_s_24 opac_7 animation_3"
            style="width:80px;height:80px;left:353px;top:67px;"
          >运营</div>
          <div
            class="bubble_base b_c_o f_s_32 opac_8 animation_4"
            style="width:180px;height:180px;left:367px;top:242px;"
          >市场</div>
          <div
            class="bubble_base b_c_o f_s_32 animation_5"
            style="width:200px;height:200px;left:496px;top:32px;"
          >中层管理</div>
          <div
            class="bubble_base b_c_b f_s_28 opac_4 animation_6"
            style="width:150px;height:150px;left:607px;top:272px;"
          >网络营销</div>
          <div
            class="bubble_base b_c_o opac_15"
            style="width:40px;height:40px;left:708px;top:206px;"
          ></div>
          <div
            class="bubble_base b_c_o f_s_24 opac_5 animation_1"
            style="width:100px;height:100px;left:757px;top:35px;"
          >UI设计</div>
          <div
            class="bubble_base b_c_o f_s_28 opac_7 animation_2"
            style="width:180px;height:180px;left:821px;top:175px;"
          >产品培训</div>
          <div
            class="bubble_base b_c_b f_s_24 opac_4 animation_3"
            style="width:140px;height:140px;left:983px;top:50px;"
          >插画设计</div>
          <div
            class="bubble_base b_c_b opac_15"
            style="width:60px;height:60px;left:112px;top:216px;"
          ></div>
        </div>
      </div>
    </div>

    <div class="bg_color_grey">
      <div>
        <div class="title">
          <h1>学院活动</h1>
          <span @click="handleRouterSkip('List',5)">查看更多</span>
        </div>
        <div class="activity_list">
          <card-item v-for="(item,index) in new_list" :key="index" :item="item" :index="index"></card-item>
        </div>
      </div>
    </div>

    <foot-cpright></foot-cpright>
  </div>
</template>

<script>
import commHead from "@/components/comm-head.vue";
import footCpright from "@/components/foot-cpright.vue";
import cardItem from "@/components/card-item.vue";

export default {
  components: {
    commHead,
    footCpright,
    cardItem
  },
  data() {
    return {
      page: 1,
      pageSize: 3,
      totalPage: 0,
      cat: 5,
      tea_list: [
        [
          {
            name: "Elva",
            position: "多麦联合创始人&CEO",
            avatar: require("../assets/images/elva_avatar.png"),
            describe: "多麦人的道路与自信"
          },
          {
            name: "Fifi",
            position: "数据分析经理",
            avatar: require("../assets/images/fifi.png"),
            describe: "Excel表格应用"
          },
          {
            name: "Roy",
            position: "技术经理",
            avatar: require("../assets/images/roy.png"),
            describe: "技术项目复盘及经验分享"
          },
          {
            name: "Wanily",
            position: "PHP工程师",
            avatar: require("../assets/images/wanily.png"),
            describe: "比特币与区块链技术"
          },
          {
            name: "Ryan",
            position: "前端开发工程师",
            avatar: require("../assets/images/ryan.png"),
            describe: "分析vue2.X响应式原理"
          },
          {
            name: "Marico",
            position: "PHP工程师",
            avatar: require("../assets/images/marico.png"),
            describe: "用最少的代码，做最多的事情"
          }
        ]
      ],

      new_list: []
    };
  },
  created() {
    const { getActive } = this;
    getActive();
  },
  methods: {
    getActive() {
      this.$http
        .get("site/news", {
          params: {
            cat: this.cat,
            Page: this.page,
            Pagesize: this.pageSize
          }
        })
        .then(response => {
          this.new_list = response.d.Results;
          this.totalPage = response.d.TotalPage;
        });
    },
    handleRouterSkip(name, cat) {
      this.$router.push({ name, query: { cat } });
    }
  }
};
</script>

<style lang="scss" scoped>
.b_c_o {
  background-color: #ff9200;
}
.b_c_b {
  background-color: #000000;
}

.opac_15 {
  opacity: 0.15;
}

.opac_4 {
  opacity: 0.4;
}

.opac_5 {
  opacity: 0.5;
}

.opac_7 {
  opacity: 0.7;
}

.opac_8 {
  opacity: 0.8;
}

.f_s_32 {
  font-size: 32px;
}
.f_s_28 {
  font-size: 28px;
}

.f_s_24 {
  font-size: 24px;
}

.animation_1 {
  animation: buble 5s infinite;
}

.animation_2 {
  animation: buble 6s infinite;
}

.animation_3 {
  animation: buble 7s infinite;
}

.animation_4 {
  animation: buble 8s infinite;
}

.animation_5 {
  animation: buble 9s infinite;
}
.animation_6 {
  animation: buble 10s infinite;
}

.bubble_base {
  position: absolute;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.mar_b_24 {
  margin-bottom: 24px;
}

.container {
  & .head_bg {
    height: 480px;
    background-image: url("../assets/images/banner_mxy.png");
    & .head_con {
      width: 1200px;
      margin: 0 auto;
      height: 392px;
      position: relative;
      & img {
        width: 250px;
        height: 350px;
        position: absolute;
        top: 42px;
        left: 0;
        animation: head_img_opac 5s;
      }
      & > div:nth-child(2) {
        width: 38px;
        height: 30px;
        background-image: url("../assets/images/fuhao.png");
        background-repeat: no-repeat;
        background-size: 100%;
        position: absolute;
        top: 120px;
        left: 282px;
        opacity: 0.64;
        font-family: Arial-BoldMT;
        font-size: 88px;
        color: #ffffff;
        letter-spacing: 0;
        animation: textcomein_1 2s;
      }
      & > div:last-child {
        position: absolute;
        top: 144px;
        left: 342px;
        color: #fff;
        animation: textcomein 2s;
        & p:first-child {
          width: 560px;
          font-size: 40px;
          letter-spacing: 0;
          line-height: 48px;
          margin-bottom: 16px;
        }
        & p:last-child {
          width: 800px;
          font-size: 18px;
          letter-spacing: 0;
          line-height: 32px;
        }
      }
    }
  }
  & .bg_color_w {
    background-color: #fff;
    & > div {
      width: 1200px;
      margin: 0 auto;
      padding-top: 64px;
      & h1:first-child {
        margin-bottom: 32px;
      }
      & /deep/ .el-carousel {
        margin-bottom: 80px;
        & .tea_style {
          width: 100%;
          height: 100%;
          display: flex;
          flex-wrap: wrap;
          & .tea_item {
            width: 400px;
            height: 100px;
            display: flex;
            & img {
              width: 100px;
              height: 100px;
              border-radius: 50%;
              margin-right: 25px;
            }
            & > div {
              flex: 1;
              & p:first-child {
                color: #000000;
                letter-spacing: 0;
                margin-bottom: 10px;
                display: flex;
                align-items: center;
                & span:first-child {
                  font-size: 32px;
                  margin-right: 4px;
                }
                & span:last-child {
                  font-size: 16px;
                }
              }
              & p:last-child {
                font-size: 18px;
                color: #666666;
                letter-spacing: 0;
                line-height: 26px;
              }
            }
          }
        }
      }
      & .xy_course {
        height: 502px;
        position: relative;
      }
    }
  }
  & .bg_color_grey {
    background-color: #f7f7f7;
    height: 626px;
    padding-top: 64px;
    & > div {
      width: 1200px;
      margin: 0 auto;
      & .title {
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 32px;
        & > span:hover {
          color: #ff9200;
        }
      }
      & .activity_list {
        display: flex;
      }
    }
  }
}

@keyframes textcomein {
  0% {
    opacity: 0;
    top: 0px;
  }
  100% {
    opacity: 1;
    top: 144px;
  }
}

@keyframes textcomein_1 {
  0% {
    opacity: 0;
    top: 0px;
  }
  100% {
    opacity: 0.64;
    top: 120px;
  }
}
@keyframes buble {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(30px);
  }

  100% {
    transform: translateY(0px);
  }
}
</style>
